// import React, { useState } from "react";
// import VideoCard from "./Components/VideoCard";
// import VideoPlayerDialog from "./Components/VideoPlayerDialog";
// import {
//   Box,
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Chip,
// } from "@mui/material";
// import { youtubeVideos } from "./Components/VideoData";

// // A self-contained component for the hero section
// const HeroSection = () => (
//   <Card
//     variant="outlined"
//     sx={{
//       textAlign: "center",
//       p: { xs: 2, sm: 4, md: 6 },
//       mb: 6,
//       backgroundColor: "#ffffff",
//       borderColor: "rgba(0, 0, 0, 0.12)",
//     }}
//   >
//     <CardContent>
//       <Chip label="Professional Social Media Services" color="primary" />
//       <Typography
//         variant="h3"
//         component="h1"
//         gutterBottom
//         sx={{ fontWeight: "bold", mt: 2, color: "text.primary" }}
//       >
//         Grow Your Business with Expert Social Media Management
//       </Typography>
//       <Typography variant="h6" sx={{ mb: 4, color: "text.secondary" }}>
//         We help businesses establish a strong online presence through strategic
//         social media management and SEO optimization.
//       </Typography>
//       <Button
//         variant="contained"
//         size="large"
//         sx={{ px: 4, py: 1.5, fontSize: "1.1rem" }}
//       >
//         Get Started Today
//       </Button>
//     </CardContent>
//   </Card>
// );

// const HomePage = () => {
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   const handleVideoPlay = (video) => setSelectedVideo(video);
//   const handleCloseDialog = () => setSelectedVideo(null);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         backgroundColor: "#f4f6f8", // Light gray background for the page
//         py: 5,
//       }}
//     >
//       <Container maxWidth="xl">
//         <HeroSection />

//         <Card
//           variant="outlined"
//           sx={{
//             p: { xs: 2, sm: 3, md: 4 },
//             backgroundColor: "#ffffff",
//             borderColor: "rgba(0, 0, 0, 0.12)",
//           }}
//         >
//           <CardContent>
//             <Typography
//               variant="h3"
//               component="h2"
//               gutterBottom
//               textAlign="center"
//               sx={{ fontWeight: "bold", color: "text.primary" }}
//             >
//               Our YouTube Content
//             </Typography>
//             <Typography
//               variant="h6"
//               textAlign="center"
//               sx={{ mb: 4, color: "text.secondary" }}
//             >
//               Check out our latest videos on social media strategies and digital
//               marketing.
//             </Typography>

//             <Grid container spacing={3}>
//               {youtubeVideos.map((video) => (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={3}
//                   key={video.id}
//                   size={{ xs: 2, sm: 4, md: 4 }}
//                 >
//                   <VideoCard video={video} onPlay={handleVideoPlay} />
//                 </Grid>
//               ))}
//             </Grid>

//             <Box sx={{ textAlign: "center", mt: 5 }}>
//               <Button variant="contained" size="large" sx={{ px: 4 }}>
//                 Load More Videos
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>

//         <VideoPlayerDialog
//           open={!!selectedVideo}
//           onClose={handleCloseDialog}
//           video={selectedVideo}
//         />
//       </Container>
//     </Box>
//   );
// };

// export default HomePage;

import React from "react";
import { Box, Container } from "@mui/material";
import HeroSection from "./Components/HeroSection";
import YouTubeContent from "./Components/YouTubeContent";

const HomePage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
        py: 5,
      }}
    >
      <Container maxWidth={false} sx={{ px: "25px" }}>
        <HeroSection />
        <YouTubeContent />
      </Container>
    </Box>
  );
};

export default HomePage;
